import * as React from 'react';
import {
  Logging,
  API,
  ResponseError,
  NotificationData,
  httpStatusToText,
  HttpMethod,
} from '@vcd-ecm-ui/Common';
import { useDispatch } from 'react-redux';

const useTemplate = (
  gatewayEndPoint: string,
  url: string,
): [string, NotificationData] => {
  const [template, setTemplate] = React.useState(null);
  const [templateNotification, setTemplateNotification] = React.useState(null);
  const dispatch = useDispatch();

  const getTemplateOld = () => async (): Promise<void> => {
    try {
      const api = new API(gatewayEndPoint);

      const templateString: string = await api.correspondence.getTemplateV41(url);
      setTemplate(templateString);
    } catch (error) {
      const notification: NotificationData = {
        type: 'Error',
        title: 'Template Read Error',
        description: 'Unable to read Template',
        error: error as ResponseError,
      };
      setTemplateNotification(notification);
    }
  };

  const getTemplate = () => async (): Promise<void> => {
    try {
      const response: Response = await fetch(url);

      switch (response.status) {
        case 200:
          {
            const templateString = await response.text();
            setTemplate(templateString);
          }
          break;
        default:
        {
          const templateString = await response.text();
          const method = HttpMethod.GET;
          const error: ResponseError = {
            url,
            method,
            statusCode: response.status,
            statusDescription: httpStatusToText(response.status),
            statusCodeDescription: `${response.status} ${httpStatusToText(response.status)}`,
            responseBody: templateString,
            message: null,
            exception: null,
          };

          throw error;
        }
      }
    } catch (error) {
      // Detect CORS Error
      if (error.toString() === 'TypeError: Failed to fetch') {
        const notification: NotificationData = {
          type: 'Error',
          title: 'Template Read Error',
          description: 'Unable to read Template',
          error: {
            url,
            method: HttpMethod.GET,
            statusCode: 403,
            statusDescription: 'Forbidden',
            statusCodeDescription: '403 Forbidden: The Request has been blocked by a CORS policy.',
            responseBody: null,
            message: null,
            exception: null,
          },
        };
        setTemplateNotification(notification);
      } else {
        const notification: NotificationData = {
          type: 'Error',
          title: 'Template Read Error',
          description: 'Unable to read Template',
          error: error as ResponseError,
        };
        setTemplateNotification(notification);
      }
    }
  };

  React.useEffect(() => {
    if (!template) {
      dispatch(getTemplate());
    }

    return (): void => {
      // This Code will run once the component unmounts.
      setTemplate(null);
      setTemplateNotification(null);
    };
  }, []);

  return [template, templateNotification];
};

export default useTemplate;
